'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { Filter, type FilterItem } from '@terra/ui-design-system';
import {
  TRACE_STATUS_FILTER_VALUES,
  isTraceStatusFilter,
  type TraceStatusFilter,
} from '../../../store/tab/tracesTabScopedFilterStore';

export function ExecutionsStatusFilter({
  value,
  onChange,
}: {
  value: TraceStatusFilter[];
  onChange: (value: TraceStatusFilter[]) => void;
}) {
  const tExecutions = useTranslations('designSystem.executions');
  const items = useMemo(
    (): FilterItem[] =>
      TRACE_STATUS_FILTER_VALUES.map((status) => ({
        label: tExecutions(`status.${status}`),
        value: status,
      })),
    [tExecutions],
  );

  return (
    <Filter
      id="execution-status"
      density="compact"
      isMultiSelect
      placeholder={tExecutions('filters.status')}
      items={items}
      value={value}
      onChange={(values) => onChange(values.filter(isTraceStatusFilter))}
    />
  );
}
